if (!customElements.get('jky-header-actions')) {
    class JkyHeaderActions extends HTMLElement {
        constructor() {
            super();
            this.searchTrigger = this.querySelector(".header__section_search");
            this.searchEvent = this.searchEvent.bind(this);
        }
        connectedCallback() {
            this.searchTrigger?.addEventListener("click", this.searchEvent);
        }
        disconnectedCallback() {
            this.searchTrigger?.removeEventListener("click", this.searchEvent);
        }
        searchEvent() {
            const placeholder = window.pageInfo?.strings?.headerStrings?.searchPlaceholder || 'Search';
            ZModle.getInstance(`<v5-header-search class="v5-search-modal__form search-modal__form__modal" data-loading-text="Loading..." data-placeholder-text="${placeholder}" data-class="header_p_search"></v5-header-search>`, {
                id: "header-local-v5_header_main",
                class: "header-search__private",
                cb: (el) => {
                    el.querySelector("v5-header-search").setAttribute("hd-open", new Date())
                }
            })
        }
    }
    customElements.define("jky-header-actions", JkyHeaderActions);
}

if (!customElements.get('header-v5')) {
    class HeaderV5 extends HTMLElement {
        constructor() {
            super();
            this.menu_item__pc = this.querySelectorAll(".v5-header-main__menu-item");
            this.headerTop = this.querySelector("jky-v5-header");
            this.headerMain = this.querySelector(".jky-v5-header--main");
            this.searchTrigger = this.querySelector(".header__section_search");
            this.passwordFreeTriggers = this.querySelectorAll(".v5-btn--password-free");
            this.globalTriggers = this.querySelectorAll(".v5-header-actions--global");

            this.searchEvent = this.searchEvent.bind(this);
            this.passwordFreeEvent = this.passwordFreeEvent.bind(this);
            this.globalEvent = this.globalEvent.bind(this);

            this.allLazyDrawers = this.querySelectorAll('drawer-dialog[data-lazy-image]');
            this.allshopAnchors = this.querySelectorAll('menu-toggle[data-scroll-anchor]');

            this.timers = new Map();

            // 【新增】检测是否 touch 设备（iPad、iPhone 等）
            // this.isTouchDevice = 'ontouchstart' in window || (navigator.maxTouchPoints ?? 0) > 0;
            this.isTouchDevice = window.innerWidth <= 1200;
            this.handleDocumentClickForMenu = this.handleDocumentClickForMenu.bind(this);

            // 优化：保存 ResizeObserver 实例以便断开
            this.resizeObserver = null;
        }
        connectedCallback() {
            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.setHeaderPos();

            if ('requestIdleCallback' in window) {
                requestIdleCallback(() => this.loadGlobalData());
            } else {
                setTimeout(this.loadGlobalData(), 1000);
            }

            this.passwordFreeTriggers.forEach(item => item.addEventListener("click", this.passwordFreeEvent));
            this.globalTriggers.forEach(item => item.addEventListener("click", this.globalEvent))
            this.searchTrigger?.addEventListener("click", this.searchEvent);

            this.menu_item__pc.forEach(item => {
              if (!this.isTouchDevice) {
                item.addEventListener("mouseenter", () => {
                    if (this.timers.has(item)) {
                        clearTimeout(this.timers.get(item));
                    }

                    // 设置一个延迟触发逻辑的定时器
                    const timer = setTimeout(() => {
                        if(item.hasAttribute("data-unhover")) return
                        if(item.hasAttribute("data-lazy-image")) {
                            this.loadImags(item);
                        }

                        jkyUtils?.disablePageScroll?.();
                        this.classList.add("menu--open");
                    }, 120); // 延迟 120ms

                    this.timers.set(item, timer);

                    // 关闭搜索
                    document.querySelector('v5-header-search')?.innerDOM?.querySelector?.(".search-modal__close-button")?.click?.();
                })

                item.addEventListener("mouseleave", () => {
                    if (this.timers.has(item)) {
                        clearTimeout(this.timers.get(item));
                        this.timers.delete(item);
                    }
                    jkyUtils?.enablePageScroll?.();
                    this.classList.remove("menu--open")
                })
              }else{
                item.addEventListener("click", (e) => {
                    // 如果点击的是已经打开的下拉内容内部（左侧分类或右侧商品卡），不关闭菜单
                    if (e.target.closest('.v5-header-main__shop-content')) {
                        return;
                    }

                    const isOpen = this.classList.contains("menu--open");

                    if (isOpen) {
                        this.classList.remove("menu--open");
                        jkyUtils?.enablePageScroll?.();
                    } else {
                        this.classList.add("menu--open");
                        jkyUtils?.disablePageScroll?.();

                        // 确保第一次打开时左侧第一个分类被激活（防止空白）
                        const firstTarget = item.querySelector(".v5-shop-menu-left [data-shoptarget]");
                        if (firstTarget && !firstTarget.classList.contains('active')) {
                            // 触发 JkyShopMenu 内部的激活逻辑
                            setTimeout(() => {
                                firstTarget.click();
                            }, 10);
                        }
                    }
                    e.stopImmediatePropagation();
                });
              }
            })

            // ==================== 【新增】点击空白处关闭（iPad 体验必需） ====================
            document.addEventListener('click', this.handleDocumentClickForMenu);

            // this.allLazyDrawers.forEach(drawer => {
            //     drawer.openCallback = this.loadImags
            // })

            if(window.innerWidth < 1024) {
                this.querySelectorAll(".v5-pictext-menu-mobile__content,.v5-shop-grid--mb").forEach((content) => {
                    setTimeout(() => {
                        this.loadImags(content);
                    }, 2000);
                })
            }

            this.allshopAnchors.forEach(toggle => {
                toggle.addEventListener("click", () => {
                    setTimeout(() => {
                        if(!toggle.classList.contains('active')) return;
                        try {
                            this.scrollToChild(toggle.closest(".drawer__content"), toggle)
                        } catch(e) {
                            console.warn("mobile shop menu anchor scroll error:", e)
                        }
                    }, 20)
                })
            })

            this.querySelectorAll(".v5-shop-view_more").forEach(btn => {
                btn.addEventListener("click", () => {
                btn.classList.toggle("show-all");
                const content = btn.parentNode?.previousSibling
                console.log(content)
                content && content.classList.toggle("show-all");
                })
            })

            this.querySelectorAll(".header-v5__logout").forEach(item => {
                item.addEventListener("click", (e) => {
                e.preventDefault();
                const logoutHref = item.getAttribute("href") || "";
                try {
                    Jackery?.Utils?.cookie?.erase("_jk_user");
                    Jackery?.Utils?.cookie?.erase("_jk_id");
                    Jackery?.Utils?.cookie?.erase("_jk_quick_logined");
                    Jackery?.Utils?.cookie?.erase("discount_code");
                    setTimeout(() => {
                    if (logoutHref) {
                        window.location.href = logoutHref;
                    }
                    }, 0);
                } catch (error) {
                    console.warn("HeaderV5 logout error:", error);
                    setTimeout(() => {
                    if (logoutHref) {
                        window.location.href = logoutHref;
                    }
                    }, 0);
                }
                })
            })
        }

        // 【新增】document click 处理器
        handleDocumentClickForMenu(e) {
            if (!this.classList.contains("menu--open")) return;

            const clickedInside = Array.from(this.menu_item__pc).some(item => item.contains(e.target));
            if (!clickedInside) {
                this.classList.remove("menu--open");
                jkyUtils?.enablePageScroll?.();
            }
        }

        disconnectedCallback() {
            this.searchTrigger?.removeEventListener("click", this.searchEvent);
            document.removeEventListener('click', this.handleDocumentClickForMenu);
            this.passwordFreeTriggers.forEach(item => item.removeEventListener("click", this.passwordFreeEvent));
            this.globalTriggers.forEach(item => item.removeEventListener("click", this.globalEvent));
            // 断开 ResizeObserver
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
        }
        setHeaderHeight() { // 初始化header尺寸 
            // 使用 requestAnimationFrame 避免强制同步重排
            requestAnimationFrame(() => {
                const topHeight = this.headerTop?.offsetHeight || 0;
                const mainHeight = this.headerMain?.offsetHeight || 0;

                this.headerTop && document.documentElement.style.setProperty('--header-top-height', `${topHeight}px`);
                this.headerMain && document.documentElement.style.setProperty('--header-main-height', `${mainHeight}px`);
            });
        }
        setHeaderPos() {
            // 优化：在 ResizeObserver 回调中批量设置 CSS 变量
            this.resizeObserver = new ResizeObserver((entries) => {
                // 使用 requestAnimationFrame 延迟批量更新
                requestAnimationFrame(() => {
                    const entry = entries[0];
                    if (!entry) return;
                    const root = document.documentElement;
                    const { bottom, height } = entry.contentRect;
                    const mainRect = this.querySelector('.jky-v5-header--main')?.getBoundingClientRect();
                    const mainTop = mainRect?.top ?? 0;

                    // 批量设置 CSS 变量，减少多次重排
                    root.style.setProperty('--header-pos-bottom', `${bottom}px`);
                    root.style.setProperty('--jky-header-h', `${bottom}px`);
                    document.querySelector("body")?.style.setProperty('--jky-header-h', `${bottom}px`);
                    root.style.setProperty('--header-height', `${height}px`);
                    try {
                        if (mainRect) {
                            document.documentElement.style.setProperty('--header-main-pos-top', `${mainTop}px`);
                        }
                    } catch(e) {
                        console.warn("HeaderV5 error:", e);
                    }
                });
            });
            this.resizeObserver.observe(this);

            this.posObserver = new MutationObserver(() => {
                // 同一帧内多次 style 变更只算一次，并且值不变时不写
                // （往 :root 写自定义属性会让整篇文档样式失效，滚动每帧写会明显掉帧）
                if (this._posTopRaf) return;
                this._posTopRaf = requestAnimationFrame(() => {
                    this._posTopRaf = 0;
                    const top = Math.round(Math.abs(this.getBoundingClientRect().top) || 0);
                    if (top === this._lastPosTop) return;
                    this._lastPosTop = top;
                    document.documentElement.style.setProperty('--header-pos-top', `${top}px`);
                });
            });

            this.posObserver.observe(this, {
                attributes: true,
                attributeFilter: ['style', 'class']
            });


            // --------------------------------------------------
            // Scroll
            // --------------------------------------------------
            let scrollRaf = false;
            let lastHeaderBottom = null;
            const updateHeaderPosition = () => {
                // --------------------------------------------------
                // --header-pos-bottom
                // --jky-header-h
                // --------------------------------------------------
                const headerRect = this.getBoundingClientRect();
                const bottom = Math.round(headerRect.bottom);
                if (bottom !== lastHeaderBottom) {
                    const root = document.documentElement;
                    lastHeaderBottom = bottom;
                    root.style.setProperty(
                        '--header-pos-bottom',
                        `${bottom <= 0 ? 0 : bottom}px`
                    );
                }
            }
            this._headerScrollHandler = () => {
                if (scrollRaf) return;
                scrollRaf = requestAnimationFrame(() => {
                    scrollRaf = 0;
                    updateHeaderPosition();
                });
            };

            window.addEventListener(
                'scroll',
                this._headerScrollHandler,
                { passive: true }
            );
        }
        searchEvent() {
            const placeholder = window.pageInfo?.strings?.headerStrings?.searchPlaceholder || 'Search';
            ZModle.getInstance(`<v5-header-search class="v5-search-modal__form search-modal__form__modal" data-loading-text="Loading..." data-placeholder-text="${placeholder}" data-class="header_p_search"></v5-header-search>`, {
                id: "header-local-v5_header_main",
                class: "header-search__private",
                cb: (el) => {
                    el.querySelector("v5-header-search").setAttribute("hd-open", new Date())
                }
            })
        }
        passwordFreeEvent(e) {
            const target = e.target
            setTimeout(() => {
                target?.closest("menu-down")?.close()
            }, 0);
            window.jackeryLoginApp?.modalLogin?.({
                "register_act": "Account-Register"
            });
        }
        globalEvent() {
            const content = this.global_content || this.loadGlobalData();
            const headerTitle = window.pageInfo?.strings?.headerStrings?.localTitle || 'Select Region';

            ZModle.getInstance(content, {
                header: headerTitle,
                id: "header-v5-global",
                class: "header__changeLocal__v5"
            })
        }
        loadGlobalData() { // 获取国家地区
            if(this.global_content) return this.global_content;

            const scriptTag = document.querySelector("#metafield-shop-list");
            if (!scriptTag) throw new Error("V5 header: Metafield shop list not found");

            const res = JSON.parse(scriptTag.textContent);
            const list = res.data.lists || [];
            const current = res.data.current || {};

            const isMobile = window.innerWidth < 1024;
            const iconUrl = isMobile ? 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/car-icon-mb.svg?v=1700637746' : 'https://cdn.shopify.com/s/files/1/0550/0524/9633/files/car-icon-pc.svg?v=1700637743';

            const htmlParts = list.map(item => {
                const subListHTML = (item.child || []).map(subItem => {
                    const cartIcon = subItem.saleShow === 1 
                        ? `<i aria-hidden="true" focusable="false" class="jky-fa-shopping-cart h-3 w-3" style="background: url('${iconUrl}') center center / cover no-repeat;"></i>` 
                        : '';
                    const cur_item = `${pageInfo?.lang?.toUpperCase?.()}_${pageInfo?.cr?.toUpperCase?.()}`
                    const activeClass = (cur_item === subItem.language_code) ? 'active pointer-events-none' : '';

                    return `
                        <a href="${subItem.domain}" class="countrylist--item transition-slow-ease countrylist--item--v5 list-none rounded-sm cursor-pointer text-sm h-12 mb-3 px-4 align-baseline flex items-center ga-data ${activeClass}">
                            <li class="w-full flex items-center">
                                <span style="margin-right: 4px;" class="color-text-main-secondery countrylist--desc">${subItem.official_country}</span>
                                ${
                                    subItem.is_beat == 1 ? `<div style="background-color: #E8E8E5;color: rgba(0,0,0,0.65);" class="text-xs font-normal py-px px-1 rounded-sm">Beta</div>` : ''
                                }
                                <span class="color-text-info countrylist--lang flex-1 flex justify-end">
                                    ${subItem.saleShow === 1 ? subItem.currency + ' / ' : ''}${subItem.official_language}
                                </span>
                            </li>
                        </a>`;
                }).join('');

                return `
                    <div class="countrybox mb-8">
                        <p class="color-text-main countrybox--title mb-3 text-base font-normal">${item.continent}</p>
                        <ul class="countrylist grid grid-cols-3 lg:gap-x-2.5">
                            ${subListHTML}
                        </ul>
                    </div>`;
            });

            this.global_content = `<div class="local-content country-body">${htmlParts.join('')}</div>`;
            return this.global_content;
        }

        loadImags(container) {
            if(container.hasAttribute("lazy-loded")) return;
            const imgs = container.querySelectorAll("[data-src]");
            imgs.forEach(img => {
                img.setAttribute("src", img.getAttribute("data-src"));
                img.removeAttribute("data-src");
                img.classList.add("img-loading");
                img.addEventListener("load", () => {
                    img.classList.add("img-loaded");
                    img.parentElement.classList.add("img-inited");
                });
            });
            container.setAttribute("lazy-loded", "");
        }
        scrollToChild(parentElement, childElement) {
            // 读取 offsetTop 可能触发重排，但仅在用户点击时发生，频率低，可接受
            const top = childElement ? childElement.offsetTop - 24 : 0;
            parentElement && parentElement.scrollTo({ top: top });
        }
    }
    customElements.define("header-v5", HeaderV5);
}